// import React, { useEffect, useState } from "react";
// import AuthLayout from "../../layouts/AuthLayout";
// import { Button, Input } from "@nextui-org/react";
// import { Link, useNavigate } from "react-router-dom";
// import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
// import { useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import axios from "axios";
// import { useDispatch } from "react-redux";
// import { addAuth } from "../../store/slices/authSlice";
// import CustomButton from "../CustomButton";
// import { loginSchema } from "./validationSchemas";
// import { toast } from "react-toastify";

// const Login = () => {
//   const [showPassword, setShowPassword] = useState(false);

//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     reset,
//   } = useForm({
//     resolver: yupResolver(loginSchema),
//   });

//   const onSubmit = async (data) => {
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_SERVER_URL}/users/login`,
//         data
//       );
//       const responseData = response?.data.details;
//       localStorage.setItem("user_details", JSON.stringify(responseData.user));
//       localStorage.setItem("accessToken", responseData.accessToken);
//       localStorage.setItem("refreshToken", responseData.refreshToken);
//       localStorage.setItem("role", responseData.user.role);
//       localStorage.setItem("user_id", responseData.user.id);
//       dispatch(addAuth({ ...responseData }));
//       if (
//         (responseData.user?.role === "SUPPLIER" ||
//           responseData.user?.role === "CUSTOMER") &&
//         (responseData.user?.status === "BLOCKED_BY_USER" ||
//           responseData.user?.status === "BLOCKED_BY_ADMIN")
//       ) {
//         toast.error("You Are Blocked");
//         return;
//       }

//       if (responseData.user?.role === "ADMIN") {
//         navigate("/administration");
//       } else {
//         navigate("/requests");
//       }
//       reset();
//     } catch (error) {
//       // console.log(error)
//       toast.error(error?.response?.data.message);
//     }
//   };

//   // useEffect(() => {
//   //   let token = localStorage.getItem("accessToken");
//   //   if (token) {
//   //     navigate("/requests");
//   //   }
//   // }, [navigate]);
//   useEffect(() => {
//     const token = localStorage.getItem("accessToken");
//     if (!token) return;

//     const role = localStorage.getItem("role");
//     if (role === "ADMIN") {
//       navigate("/administration");
//     } else {
//       navigate("/requests");
//     }
//   }, [navigate]);

//   return (
//     <AuthLayout>
//       <form className="xl:px-10" onSubmit={handleSubmit(onSubmit)} noValidate>
//         <div className="text-center">
//           <h2 className="md:text-3xl text-2xl">Welcome Again!</h2>
//         </div>
//         <div className="mt-16 mb-8 [&>*:not(:last-child)]:mb-5">
//           <div>
//             <Input
//               {...register("email")}
//               type="email"
//               variant="bordered"
//               label="Email"
//               labelPlacement="outside"
//               placeholder=" "
//               isRequired
//               errorMessage={errors.email?.message}
//             />
//           </div>

//           <div className="relative border-2 border-white ">
//             <div className="absolute right-1  ">
//               <Link
//                 to="/forgot-password"
//                 className="auth_link_2 text-xs text-lightBlue"
//               >
//                 Forgot Password?
//               </Link>
//             </div>
//             <Input
//               {...register("password")}
//               type={showPassword ? "text" : "password"}
//               variant="bordered"
//               label="Password"
//               labelPlacement="outside"
//               placeholder=" "
//               isRequired
//               errorMessage={errors.password?.message}
//               endContent={
//                 <button
//                   className="focus:outline-none"
//                   type="button"
//                   onClick={() => setShowPassword(!showPassword)}
//                 >
//                   {showPassword ? (
//                     <AiOutlineEye className="password_eye_icon" />
//                   ) : (
//                     <AiOutlineEyeInvisible className="password_eye_icon" />
//                   )}
//                 </button>
//               }
//             />
//           </div>
//         </div>
//         <div>
//           <CustomButton text="Login" />
//         </div>
//         <div className="text-sm text-center mt-12">
//           <p>Don't have an account?</p>
//           <div className="flex gap-2 items-center justify-center mt-1">
//             <div className="w-12 border-[0.5px] border-purpleBt"></div>
//             <div>Sign Up As</div>
//             <div className="w-12 border-[0.5px] border-purpleBt"></div>
//           </div>
//           <div className="flex gap-3 justify-center mt-2">
//             <Link to="/signup/CUSTOMER">
//               <Button className="bg-transparent border-2 border-lightBlue text-lightBlue hover:bg-lightBlue hover:border-none hover:text-white px-4">
//                 CUSTOMER
//               </Button>
//             </Link>
//             {/* <Link to='/signup/SUPPLIER'><Button className="bg-transparent border-2 border-lightBlue text-lightBlue hover:bg-lightBlue hover:border-none hover:text-white px-[22px]">SUPPLIER</Button></Link> */}
//           </div>
//           <div className="flex items-center justify-center  mt-5">
//             <Link
//               to="/supplier"
//               className="text-lightBlue hover:underline hover:text-blue-600 transition duration-200"
//             >
//               Keen to become a supplier on WrecKonnect?
//             </Link>
//           </div>
//         </div>
//       </form>
//     </AuthLayout>
//   );
// };

// export default Login;

import React, { useEffect, useState } from "react";
import { Button, Input } from "@nextui-org/react";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import axios from "axios";

import AuthLayout from "../../layouts/AuthLayout";
import CustomButton from "../CustomButton";
import { loginSchema } from "./validationSchemas";

import { useDispatch } from "react-redux";
import { addAuth } from "../../store/slices/authSlice";

/* ------------------------------------------------------------------ */
/* 🔑  Login page                                                     */
/* ------------------------------------------------------------------ */
const Login = () => {
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  /* ---------------------------------------------------------------- */
  /* 📝  react-hook-form + YUP                                        */
  /* ---------------------------------------------------------------- */
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(loginSchema) });

  /* ---------------------------------------------------------------- */
  /* 🚀  Submit handler                                               */
  /* ---------------------------------------------------------------- */
  const onSubmit = async (data) => {
    console.log("%c[LOGIN] 🚀 Attempting login", "color:#2196f3", data.email);

    try {
      const { data: res } = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/users/login`,
        data
      );

      const { user, accessToken, refreshToken } = res.details;
      console.log("%c[LOGIN] ✅ Login success", "color:#4caf50", user.email);

      /* store tokens & user */
      localStorage.setItem("user_details", JSON.stringify(user));
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("role", user.role);
      localStorage.setItem("user_id", user.id);
      localStorage.setItem("create_date", user.createdAt);

      dispatch(addAuth({ ...res.details }));

      /* Blocked users? */
      if (
        ["SUPPLIER", "CUSTOMER"].includes(user.role) &&
        ["BLOCKED_BY_USER", "BLOCKED_BY_ADMIN"].includes(user.status)
      ) {
        toast.error("You are blocked");
        return;
      }

      /* Redirect based on role */
      navigate(user.role === "ADMIN" ? "/administration" : "/requests");
      reset();
    } catch (err) {
      console.error("%c[LOGIN] ❌ Login failed", "color:red", err.response);
      toast.error(err?.response?.data?.message || "Login failed");
    }
  };

  /* ---------------------------------------------------------------- */
  /* 🔄  If token already present, skip login page                    */
  /* ---------------------------------------------------------------- */
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) return;

    const role = localStorage.getItem("role");
    navigate(role === "ADMIN" ? "/administration" : "/requests");
  }, [navigate]);

  /* ---------------------------------------------------------------- */
  /* 🖼️  UI                                                           */
  /* ---------------------------------------------------------------- */
  return (
    <AuthLayout>
      <form className="xl:px-10" onSubmit={handleSubmit(onSubmit)} noValidate>
        {/* Heading --------------------------------------------------- */}
        <div className="text-center">
          <h2 className="md:text-3xl text-2xl">Welcome Again!</h2>
        </div>

        {/* Inputs ---------------------------------------------------- */}
        <div className="mt-16 mb-8 [&>*:not(:last-child)]:mb-5">
          {/* Email --------------------------------------------------- */}
          <Input
            {...register("email")}
            type="email"
            variant="bordered"
            label="Email"
            labelPlacement="outside"
            placeholder=" "
            isRequired
            errorMessage={errors.email?.message}
          />

          {/* Password ------------------------------------------------ */}
          <div className="relative border-2 border-white">
            <div className="absolute right-1">
              <Link
                to="/forgot-password"
                className="auth_link_2 text-xs text-lightBlue"
              >
                Forgot Password?
              </Link>
            </div>
            <Input
              {...register("password")}
              type={showPassword ? "text" : "password"}
              variant="bordered"
              label="Password"
              labelPlacement="outside"
              placeholder=" "
              isRequired
              errorMessage={errors.password?.message}
              endContent={
                <button
                  className="focus:outline-none"
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <AiOutlineEye className="password_eye_icon" />
                  ) : (
                    <AiOutlineEyeInvisible className="password_eye_icon" />
                  )}
                </button>
              }
            />
          </div>
        </div>

        {/* Submit button -------------------------------------------- */}
        <CustomButton text="Login" />

        {/* Sign-up links ------------------------------------------- */}
        <div className="text-sm text-center mt-12">
          <p>Don't have an account?</p>

          <div className="flex gap-2 items-center justify-center mt-1">
            <div className="w-12 border-[0.5px] border-purpleBt"></div>
            <div>Sign Up As</div>
            <div className="w-12 border-[0.5px] border-purpleBt"></div>
          </div>

          <div className="flex gap-3 justify-center mt-2">
            <Link to="/signup/CUSTOMER">
              <Button className="bg-transparent border-2 border-lightBlue text-lightBlue hover:bg-lightBlue hover:border-none hover:text-white px-4">
                CUSTOMER
              </Button>
            </Link>
            {/* Supplier signup route is disabled for now */}
          </div>

          {/* <div className="flex items-center justify-center mt-5">
            <Link
              to="/supplier"
              className="text-lightBlue hover:underline hover:text-blue-600 transition duration-200"
            >
              Keen to become a supplier on WrecKonnect?
            </Link>
          </div> */}
        </div>
      </form>
    </AuthLayout>
  );
};

export default Login;
